import type { FormOptions } from '@customTypes/types';

export const helpWithOptions: FormOptions = {
  ai: 'Private Cloud AI',
  business: 'Private Cloud Business Edition',
  enterprise: 'Private Cloud Enterprise (PCE)',
};

export const businessOptions: FormOptions = {
  dhci: 'dHCI',
  alletraStorageBlock: 'HPE Alletra Storage MP for Block',
  simpliVity: 'SimpliVity',
};

export const enterpriseOptions: FormOptions = {
  containers: 'Containers (xCaaS)',
  bareMetal: 'BareMetal (BMaaS)',
  virtualMachines: 'Virtual Machines (VMaaS)',
}

export const helpWithThirdOptions: string[] = [
  'Performance issue',
  'Cloud Management Portal issues',
  'Provisioning related issues',
  'System degraded/Down/Not responding',
  'Other',
];

export const severityOptions: FormOptions = {
  high: 'High (widespread impact - business/timelines, etc)',
  medium: 'Medium (service impacted partially; not down)',
  low: 'Low (no impact to business)',
};
